import {Loading} from 'components/form';
import React from 'react';
import loadingGif from 'assets/images/loading.gif'

export default function Item({item, selected, select}) {

   return (
      <>
         <div onClick={(e) => {
            select(item);
            e.stopPropagation()
         }}
              className={`h-42 w-3/12 flex p-1 mb-2 mx-1 bg-white flex-col border hover:bg-violet-100 cursor-pointer rounded shadow-sm hover:shadow-md ${selected ? " bg-violet-100" : ""}`}>
            <div className="gallery-item-container">
               <div className="w-full flex justify-center items-center">
                  <img className="w-full h-full gallery-image-item rounded" src={item.url || loadingGif}/>
               </div>
            </div>
            <hr className="my-2"/>
            <h5 className="px-1 py-1 font-bold text-sm text-gray-500 text-center hover:text-violet-600">
               {item.name}
            </h5>
         </div>
      </>
   );
}
